var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4448 5.09124C4.37355 5.85124 4.32355 7.19624 4.7723 7.76874C4.7723 7.76874 4.56105 6.29124 6.4548 4.43749C7.2173 3.69124 7.39355 2.67624 7.1273 1.91499C6.97605 1.48374 6.6998 1.12749 6.4598 0.878737C6.3198 0.732487 6.4273 0.491237 6.63105 0.499987C7.86355 0.554987 9.86105 0.897487 10.7098 3.02749C11.0823 3.96249 11.1098 4.92874 10.9323 5.91124C10.8198 6.53874 10.4198 7.93374 11.3323 8.10499C11.9836 8.22749 12.2986 7.70999 12.4398 7.33749C12.4986 7.18249 12.7023 7.14374 12.8123 7.26749C13.9123 8.51874 14.0061 9.99249 13.7786 11.2612C13.3386 13.7137 10.8548 15.4987 8.3873 15.4987C5.3048 15.4987 2.85105 13.735 2.2148 10.5425C1.95855 9.25374 2.08855 6.70374 4.07605 4.90374C4.22355 4.76874 4.4648 4.88874 4.4448 5.09124Z",
    fill: "url(#paint0_radial_235_17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51384 9.67739C8.37759 8.21489 8.88634 6.54614 9.16509 5.88114C9.20259 5.79364 9.10259 5.71114 9.02384 5.76489C8.53509 6.09739 7.53384 6.87989 7.06759 7.98114C6.43634 9.46989 6.48134 10.1986 6.85509 11.0886C7.08009 11.6249 6.81884 11.7386 6.68759 11.7586C6.56009 11.7786 6.44259 11.6936 6.34884 11.6049C6.07919 11.3459 5.887 11.017 5.79384 10.6549C5.77384 10.5774 5.67259 10.5561 5.62634 10.6199C5.27634 11.1036 5.09509 11.8799 5.08634 12.4286C5.05884 14.1249 6.46009 15.4999 8.15509 15.4999C10.2913 15.4999 11.8476 13.1374 10.6201 11.1624C10.2638 10.5874 9.92884 10.2111 9.51384 9.67739Z",
    fill: "url(#paint1_radial_235_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_235_17",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.77677 15.5376) rotate(-179.751) scale(8.82346 14.4775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_235_17",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.27258 6.75719) rotate(90.5787) scale(9.23205 6.94781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF8BD",
    stopOpacity: 0.804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF6AB",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF38D",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF176",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.bfc2960691e2bb48dcb3bbd9368f6ffe.svg";
export { ForwardRef as ReactComponent };